import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { request, reportErrorToHoneybadger } from '../../helpers/Requests'

class Setup extends Component {
  state = {
    loaded: false
  };

  convertResellerId(resellerId) {
    switch(resellerId) {
      case 1:
        return "PCS"
      case 2:
        return "Cool Care"
      default:
        return ""
    }
  }

  componentDidMount() {
    request('GET', "/v1/a/sessions", null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        localStorage.setItem('access_levels', data.access_levels);
        localStorage.setItem('license', data.license);
        localStorage.setItem('access_levels', data.access_levels);
        localStorage.setItem('staff_fulfilment_access', data.staff_fulfilment_access);
        localStorage.setItem('latestReseller', this.convertResellerId(data.reseller_id));
        localStorage.setItem('type_of_organisation', data.type_of_organisation);
        localStorage.setItem('organisationName', data.organisation_name);
        localStorage.setItem('enrolmentCode', data.enrolment_code);
        data.logo ? localStorage.setItem('logo', data.logo) : localStorage.removeItem('logo')
        data.border_color ? localStorage.setItem('borderColor', data.border_color) : localStorage.removeItem('borderColor')

        if (data.support) {
          localStorage.setItem('support', data.support);
        }
        else {
          localStorage.removeItem('support')
        }

        this.setState({ loaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error })
      })
  }

  render() {
    const { loaded, error, unauthorized } = this.state;
    const { fireLogLocation } = this.props.location

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <div>Loading...</div>
    }

    if (fireLogLocation) {
      return <Redirect to={`/fire-log?location=${fireLogLocation}`}/>
    }

    if (localStorage.getItem("access_levels") === "emergency") {
      return <Redirect to="/fire-log"/>
    }

    return <Redirect to="/"/>
  }
}

export default Setup;
